{
  "pages": [
    {
      "name": "Pressure Sensor",
      "elements": [
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "dropdown",
              "name": "Location",
              "title": "Pipe position",
              "isRequired": true,
              "choices": [
                {
                  "value": "Forward",
                  "text": "Forward"
                },
                {
                  "value": "Return",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "hasDirtCollector",
              "title": "Dirt collector?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Pressure Sensor"
        },
        {
          "type": "panel",
          "name": "panel3",
          "elements": [
            {
              "visibleIf": "{hasDirtCollector} == false",
              "type": "dropdown",
              "name": "P",
              "title": "Pressure sensor",
              "isRequired": true,
              "choices": [
                {
                  "text": "Grundfos Tryktransmitter RPI 0-0,6",
                  "value": "SensorGrundfosRPI_0_06"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-1,0",
                  "value": "SensorGrundfosRPI_0_10"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-1,6",
                  "value": "SensorGrundfosRPI_0_16"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-2,5",
                  "value": "SensorGrundfosRPI_0_25"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-4,0",
                  "value": "SensorGrundfosRPI_0_40"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-6,0",
                  "value": "SensorGrundfosRPI_0_60"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-10,0",
                  "value": "SensorGrundfosRPI_0_100"
                },
                {
                  "text": "Grundfos Tryktransmitter RPI 0-25,0",
                  "value": "SensorGrundfosRPI_0_250"
                },
                {
                  "text": "BELIMO_22WP-114_0-4,0 Bar",
                  "value": "SensorBelimo22WP114"
                },
                {
                  "text": "BELIMO_22WP-115_0-6,0 Bar",
                  "value": "SensorBelimo22WP115"
                },
                {
                  "text": "BELIMO_22WP-116_0-10,0 Bar",
                  "value": "SensorBelimo22WP116"
                },
                {
                  "text": "BELIMO_22WP-117_0-16,0 Bar",
                  "value": "SensorBelimo22WP117"
                }
              ]
            }
          ],
          "title": "Sensor"
        },
        {
          "type": "panel",
          "title": "Sensor",
          "name": "diffPressSensor",
          "visibleIf": "{hasDirtCollector} == true",
          "elements": [
            {
              "type": "dropdown",
              "name": "DP",
              "title": "Differential pressure sensor",
              "isRequired": true,
              "choices": [
                {
                  "text": "Grundfos DPI 2+T 0-0,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_06"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_10"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_16"
                },
                {
                  "text": "Grundfos DPI 2+T 0-2,5 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_25"
                },
                {
                  "text": "Grundfos DPI 2+T 0-4,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_40"
                },
                {
                  "text": "Grundfos DPI 2+T 0-6,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_60"
                },
                {
                  "text": "Grundfos DPI 2+T 0-10,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_100"
                },
                {
                  "text": "Grundfos DPI 2+T 0-16,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_160"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}